import type { ShopperReservationMode } from '@iheartjane/types';

import { resolveSelectedMode } from './resolveSelectedMode';

// Narrows `modes` to the ones that actually have bookable slots right now.
export const modesWithSlots = (
  modes: readonly ShopperReservationMode[],
  hasSlots: { curbside: boolean; delivery: boolean; pickup: boolean }
): ShopperReservationMode[] => modes.filter((mode) => hasSlots[mode]);

// The one-time seed decision shared by every fulfillment toggle: where should
// the shopper be moved to, given what has slots? `null` means leave them where
// they are.
export const resolveModeChange = (
  reservationMode: string | undefined,
  pickupSubMode: string | undefined,
  slotOpenModes: readonly ShopperReservationMode[],
  selectableModes: readonly ShopperReservationMode[]
): ShopperReservationMode | null => {
  const current = resolveSelectedMode(reservationMode, pickupSubMode);
  const target = resolveSelectedMode(
    reservationMode,
    pickupSubMode,
    slotOpenModes.length ? slotOpenModes : selectableModes
  );

  if (target === current) return null;

  if (!reservationMode) return target;

  if (!selectableModes.includes(current)) return target;

  if ((target === 'delivery') !== (current === 'delivery')) return null;

  return target;
};
